import { motion } from 'motion/react';

const SliderMotion = ({
  children,
  keyProp,
  isBackward = false,
  className = '',
  disabled = false,
  duration = 0.1,
  stiffness = 300,
  damping = 30,
  opacity = 0,
  delay = 0,
  yAxis = 100,
  transition = {},
  turnOffOpacityTransition = false,
}) => {
  return (
    <motion.div
      key={keyProp}
      initial={disabled ? false : { opacity, y: isBackward ? -yAxis : yAxis }}
      animate={disabled ? false : { opacity: 1, y: 0 }}
      exit={disabled ? false : { opacity: 0, y: isBackward ? yAxis : -yAxis }}
      className={className}
      transition={{
        duration,
        y: { type: 'spring', stiffness, damping, delay },
        opacity: turnOffOpacityTransition ? false : { duration, delay },
        ...transition,
      }}>
      {children}
    </motion.div>
  );
};

export default SliderMotion;
